module.exports = __webpack_public_path__ + "static/media/guide-icon.b2520be8.svg";